export const organizationTopicIds = [
	'chat-mention',
	// [ROME-3344]
	'transaction-completed',
	'job-completed',
	// [ROME-4329]
	'job-created',
	// [ROME-224] one topic per remaining emailable notification type
	'job-assignment',
	'transaction-assignment',
	'transaction-unassigned',
	'transaction-reworked',
	'transaction-unallocated',
	'fpc-job-completed',
	'recipe-copy-completed',
	'recipe-copy-failed',
] as const;

export const otherIds = [] as const;

export const ids = [...organizationTopicIds, ...otherIds] as const;
